module.exports = __webpack_public_path__ + "media/src/images/proctored_icons/no_local_browsing-56e012d042587e0e6489826a270636bb.svg";